import { Organization } from "../../../models/organization.model.ts";
import { OrganizationSerializer } from "../../../models/serializers/organizationSerializer.ts";
import { httpRequest } from "../../http";

export class CommandGetOrganizations {
    async run(organizationId: number, limit: number, offset: number) {

        const base = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/`;

        const params = new URLSearchParams(
            {
                    organization: String(organizationId),
                    limit: String(limit),
                    offset: String(offset)
                });

        const url = `${base}?${params.toString()}`;

        try {
            const response = await httpRequest<any>(url, { method: "GET" });

            return this.deserialize(response);

        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) : Organization[]{
        const serializer = new OrganizationSerializer();
        return serializer.deserializeList(data);
    }
}



